export default "__VITE_ASSET__DjI_Nq4E__"